function subtract(firstNumber, secondNumber) {
  return (firstNumber * 100 - secondNumber * 100) / 100;
}

export { subtract };
